async function postChangeTimeslotStatusAPI(data) {
  return await window.fetch('/webapi/timeslots/api/v1/staying_statuses/timeslot/change_status', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export default postChangeTimeslotStatusAPI;
